// Import Packages
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';

// Import Material UI
import { TextField, Select, MenuItem } from '@material-ui/core';

// Import Pages
import { Checkboxes } from '../../../FlowConfigurationInputs';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

// Import Helper
import { CheckIfFlowUpdated } from '../../../../helpers/helper';

// Import Recoil
import { saveAvailable, initialActions, changedFields } from "../../../../recoil-store/recoil-state";


export default function Delete({ action, variables, setOpenVariable, visible }) {
  const { t } = useTranslation();
  const label = 'CONTENT.CONFIGURATION-FORM.ARRAY.';
  const initialActionsData = useRecoilValue(initialActions);
  const setSaveAvailable = useSetRecoilState(saveAvailable);
  const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);
  const [value, setValue] = useState("index");
  const [startIndex, setStartIndex] = useState(0);
  const [indexCount, setIndexCount] = useState(1);

  useEffect(() => {
    if (!action.fields['option']) {
      action.fields['option'] = { value: 'index', isRequired: true };
    }

    if (action.fields.startIndex) {
      setStartIndex(action.fields.startIndex.value);
    } else {
      action.fields.startIndex = { value: 0, isRequired: true };
      setStartIndex(0);
    }

    if (action.fields.indexCount) {
      setIndexCount(action.fields.indexCount.value);
    } else {
      action.fields.indexCount = { value: 1, isRequired: true };
      setIndexCount(1);
    }

    setValue(action.fields['option'].value);
  }, [action]);

  const handleChange = (event) => {
    setValue(event.target.value);

    if (event.target.value === 'index') {
      action.fields.startIndex = { value: 0, isRequired: true };
      action.fields.indexCount = { value: 1, isRequired: true };
      setStartIndex(0);
      setIndexCount(1);
      delete action.fields.searchElement;
    } else {
      delete action.fields.startIndex;
      delete action.fields.indexCount;
    }

    // always updated
    CheckIfFlowUpdated("option", action, "x", event.target.value, setSaveAvailable, setChangeFields, changedFieldsState);

    action.fields['option'].value = event.target.value;
  };

  const options = {
    checkboxes: { label: label + 'DELETE-ALL' },
  };

  const onChangeInput = (inputName, value) => {
    if (Number(value) < 0) {
      value = "0"
    }
    if (inputName === "startIndex") {
      setStartIndex(value);
    } else {
      if (value === "0") {
        value = "1";
      }
      setIndexCount(value);
    }

    const field = initialActionsData[action.id]?.fields[inputName];
    const oldValue = !field ? undefined : field.value;
    CheckIfFlowUpdated(inputName, action, oldValue, value, setSaveAvailable, setChangeFields, changedFieldsState);
    action.fields[inputName].value = value;
  }

  return (
    <div>
      <div className={`conf-field-container ${visible ? "display-none" : ""}`}>
        <FieldLabel name={t(label + 'ARRAY-VARIABLE')} is_required={true} />
        <TextInput action={action} inputName="variable" variables={variables}
          setOpenVariable={setOpenVariable} isRequired={true} include={['array']} fieldType="array" displayName={t(label + 'ARRAY-VARIABLE')} hideRequired={true} />
      </div>

      <div className="conf-field-container">
        <FieldLabel name={t(label + 'REMOVE-OPTION')} />
        <Select
          value={value}
          onChange={(e) => handleChange(e)}
          variant="outlined"
          fullWidth
          style={{ width: "90%" }}
        >
          <MenuItem value="index">{t(label + 'REMOVE-WITH-INDEX')}</MenuItem>
          <MenuItem value="value">{t(label + 'REMOVE-WITH-VALUE')}</MenuItem>
        </Select>
      </div>
      {
        value === "index" ?
          <div>
            <div className="conf-field-container">
              <FieldLabel name={t(label + 'START-INDEX')} is_required />
              <TextField
                variant="outlined"
                onChange={(e) => onChangeInput("startIndex", e.target.value)}
                value={startIndex} type="number"
              />
            </div>
            <div className="conf-field-container">
              <FieldLabel name={t(label + 'INDEX-COUNT')} is_required />
              <TextField
                variant="outlined"
                onChange={(e) => onChangeInput("indexCount", e.target.value)}
                value={indexCount} type="number"
              />
            </div>
          </div>
          :
          <div>
            <div className="conf-field-container">
              <FieldLabel name={t(label + 'SEARCH-ELEMENT')} is_required />
              <TextInput action={action} inputName="searchElement" variables={variables}
                setOpenVariable={setOpenVariable} refresh={value}
                isRequired hideRequired
                fieldType={'string'} displayName={t(label + 'FILTER')}
              />
            </div>
            <div className="conf-field-container">
              <Checkboxes action={action} inputName="allMatches" options={options.checkboxes} />
            </div>
          </div>
      }

      <div className="conf-field-container">
        <FieldLabel name={t(label + "ASSIGN-DELETED-ITEMS")} />
        <VariablePicker action={action} inputName="set"
          variables={variables} setOpenVariable={setOpenVariable} hideRequired={true}
          filter="array"
        />
        <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'array' })}</em></small>
      </div>
    </div>
  );
}
